<template>
  <v-autocomplete
      v-if="isTagsLoad"
      clearable
      outlined
      hide-selected
      multiple
      small-chips
      :menu-props="{bottom: true, offsetY: true}"
      :items="$store.state.tag.tags"
      item-text="name"
      item-value="id"
      :value="values"
      @input="e => $emit('input', e)"
      :label="label"
  >
    <template #item="{item}">
      <span
          :style='"color:" + (item.metaInfoColor ? "#" + item.metaInfoColor + "; font-weight:bold" : "black")'
      >
        {{item.name}}
      </span>
    </template>

    <template #selection="{item}">
      <v-chip
          close
          :color='item.metaInfoColor ? "#" + item.metaInfoColor : "primary"'
          text-color="white"
          @click:close="closeTag(item)">{{item.name}}</v-chip>
    </template>

  </v-autocomplete>
</template>

<script>

import TagService from '@/modules/core/services/tag-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Tag from '@/modules/core/data/tag';

export default {
  name: "TagComponent",
  data() {
    return {
      isTagsLoad: true
    }
  },
  props: {
    values: Array,
    label: String,
    updateHook: String
  },
  methods: {
    loadTags() {
      TagService.readAllFromAPI(
          (response) => {
            let restTags = null;
            for (var i = 0; i < response.data.length; i++) {
              restTags = DataUtils.parseDataToObjectArray(response.data, Tag);
            }
            this.$store.commit('tag/setTags', restTags);
          },
          (error) => {
            this.$logger.error("Error at TagService: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:tags')}))
          }
      );
    },
    closeTag(item){
      //removes the tag by filtering the item by id, then sending the newly filtered array as new input
      this.$emit("input", this.values.filter(v => v !== item.id));
    },
  },
  created() {
    if (!this.$store.state.tag.isLoading) {
      this.$store.commit('tag/startToLoad');
      this.loadTags();
    }
  }
}
</script>
